import React, { useState } from "react";
import ReactMarkdown from "react-markdown";

// UI components
const Button = ({ onClick, children, className, disabled }) => (
  <button onClick={onClick} disabled={disabled} className={"px-4 py-2 bg-blue-600 text-white rounded " + className}>
    {children}
  </button>
);

const Card = ({ children, className }) => (
  <div className={"border rounded shadow-md bg-white p-4 " + className}>{children}</div>
);

const CardContent = ({ children, className }) => (
  <div className={"text-sm " + className}>{children}</div>
);

// Prompt options
const prompts = [
  { id: "monthly_performance", label: "Analyze My Monthly Performance" },
  { id: "compare_top_2", label: "Compare My Top 2 Products" },
  { id: "geo_performance", label: "Geo Performance Breakdown" },
  { id: "underperforming_product", label: "Why Isn’t This Product Selling" },
  { id: "style_behavior", label: "What Style Works for My Buyers" },
  { id: "bundle_suggestions", label: "What to Bundle" },
  { id: "price_adjustment", label: "Suggest My Price Adjustment" },
  { id: "category_trending", label: "What’s Trending in My Category" },
  { id: "product_fatigue", label: "Detect Product Fatigue" },
  { id: "smart_ranking", label: "Smart Ranking Report" }
];

export default function T4LOSReportUI() {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activePrompt, setActivePrompt] = useState("");
  const [darkMode, setDarkMode] = useState(false);

  const runPrompt = async (prompt_id) => {
    setLoading(true);
    setActivePrompt(prompt_id);
    setReport(null);

    const promptMap = {
      monthly_performance: "monthly_performance",
      compare_top_2: "compare_top_2",
      geo_performance: "category_performance",
      underperforming_product: "product_fatigue",
      style_behavior: "color_preferences",
      bundle_suggestions: "ai_recommendations",
      price_adjustment: "top_margin_items",
      category_trending: "buyer_behavior",
      product_fatigue: "product_fatigue",
      smart_ranking: "top_refund_items"
    };

    const backendPromptId = promptMap[prompt_id];

    const body = {
      prompt_id: backendPromptId,
      sku_ids: backendPromptId === "compare_top_2" ? ["SKU001", "SKU002"] : []
    };

    try {
      const res = await fetch("http://207.148.123.233:8000/run-prompt", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });

      const data = await res.json();
      console.log("GPT RAW RESPONSE:", data);

      if (!data.result && !data.error) {
        setReport("⚠️ GPT returned empty or malformed response.");
        return;
      }

      const clean = (data.result || data.error || "").replace(/\\u0000/g, "").trim();
      setReport(clean);
    } catch (err) {
      setReport("❌ Failed to fetch report.");
    } finally {
      setLoading(false);
    }
  };

  const toggleMode = () => setDarkMode(!darkMode);

  return (
    <div className={`min-h-screen p-6 transition-colors duration-300 ${darkMode ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-900"}`}>
      <div className="max-w-4xl mx-auto space-y-6">
        <h1 className="text-3xl font-bold text-center">Hello Danni boss, Welcome to Enhanced AI T4los</h1>
        <h2 className="text-xl font-semibold text-center">T4LOS GPT Report Dashboard</h2>

        <div className="flex justify-center">
          <label className="mr-2">🌗 Dark Mode</label>
          <input type="checkbox" checked={darkMode} onChange={toggleMode} />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {prompts.map((p) => (
            <Button
              key={p.id}
              onClick={() => runPrompt(p.id)}
              disabled={loading}
              className={"text-left w-full " + (activePrompt === p.id ? "bg-blue-800" : "")}
            >
              {loading && activePrompt === p.id ? "Loading..." : p.label}
            </Button>
          ))}
        </div>

        {report && (
          <Card className="mt-6">
            <CardContent>
              <ReactMarkdown className="prose max-w-none prose-sm sm:prose lg:prose-lg">
                {String(report || "")}
              </ReactMarkdown>
            </CardContent>
          </Card>
        )}

        {!report && !loading && (
          <p className="text-center text-sm">Select a prompt above to generate your AI analysis.</p>
        )}
      </div>
    </div>
  );
}

